import { useEffect, useState } from 'react';

export const useWindowWidth = (debounceMs = 100): undefined | number => {
  const [width, setWidth] = useState<undefined | number>(undefined);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const handleResize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setWidth(window.innerWidth), debounceMs);
    };

    setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, [debounceMs]);

  return width;
};
